import {Component, EventEmitter, Input, OnChanges, Output} from "@angular/core";
import {DeviceModel} from "device-management/device-model";

@Component({
	selector: "device-model-search",
	template: `
		<div class="devicemodelsearch">

			<!-- LOADING VIEW -->
			<div *ngIf="isLoading" class="loading-indicator">Loading...</div>

			<!-- DEVICE MODELS RECENT SELECTIONS GRID -->
			<div *ngIf="!isLoading && inputDeviceModelRecentSelections?.length > 0">
				<h4 class="oeminstall_device_models_recent_selections">Recent Selections</h4>
				<div class="devicemodelsearch_devicegrid">
					<div class="devicemodelsearch_devicesquare"
						 *ngFor="let deviceModel of inputDeviceModelRecentSelections"
						 (click)="selectDeviceModel(deviceModel)">
						<image-container
							[width]="100"
							[height]="100"
							[src]="deviceModel.imageURL"
							[alt]="deviceModel.displayName"></image-container>
						<p><a>{{deviceModel.name}}</a></p>
					</div>

				</div>
			</div>

			<!-- SEARCH INPUT -->
			<div class="form_field" *ngIf="!isLoading">
				<label>Search for your device model by name</label>
				<input style="width: 270px;" type="text" [(ngModel)]="searchString"
					   (input)="filterDeviceModelsBySearchInput()" autofocus>
				<p class="form_helptext">Example: G1000, GTN 750, GNS 430</p>
			</div>


			<div class="devicemodelsearch_devicegrid" *ngIf="!isLoading">

				<!-- SEARCH RESULTS GRID -->
				<div class="devicemodelsearch_devicesquare" *ngFor="let deviceModel of filteredDeviceModels"
					 (click)="selectDeviceModel(deviceModel)">
					<image-container
						[width]="100"
						[height]="100"
						[src]="deviceModel.imageURL"
						[alt]="deviceModel.displayName"></image-container>
					<p><a>{{deviceModel.name}}</a></p>
				</div>

				<!-- EMPTY SEARCH RESULTS MESSAGE -->
				<div *ngIf="searchResultsAreEmpty">
					<p class="devicemodelsearch_emptyresultsmessage">No device models found.</p>
				</div>

			</div>

		</div>
	`,
})
export class DeviceModelSearchComponent implements OnChanges {
	@Input() inputDeviceModels: Array<DeviceModel>;
	@Input() inputDeviceModelRecentSelections: Array<DeviceModel>;
	@Output() deviceModelSelected = new EventEmitter<DeviceModel>();

	filteredDeviceModels: Array<DeviceModel>;
	searchString = "";

	ngOnChanges() {
		if (!this.isLoading)
			this.filterDeviceModelsBySearchInput();
	}

	get isLoading(): boolean {
		return this.inputDeviceModels == null;
	}

	get searchResultsAreEmpty(): boolean {
		return this.filteredDeviceModels && this.filteredDeviceModels.length === 0;
	}

	filterDeviceModelsBySearchInput() {
		if (this.isLoading)
			return;

		this.searchString = this.searchString.trim();

		if (this.searchString.length === 0)
			this.filteredDeviceModels = this.inputDeviceModels;

		this.filteredDeviceModels = this.inputDeviceModels.filter((deviceModel: DeviceModel) => {
			return deviceModel.name.toLowerCase().includes(this.searchString.toLowerCase());
		});
	}

	selectDeviceModel(deviceModel: DeviceModel) {
		this.deviceModelSelected.emit(deviceModel);
	}
}
